export enum ErrorType {
    Success = 'Success',
    Verify = 'Verify',
    VerifyUsingAlternate = 'VerifyUsingAlternate',
    VerificationFailed = 'VerificationFailed',
    Failure = 'Failure',
    Locked = 'Locked',
}
